<template>
  <div class="modbus-device">
    <h2>MODBUS设备管理</h2>
    
    <!-- 设备连接配置 -->
    <div class="device-config">
      <el-form :model="configForm" label-width="80px">
        <el-form-item label="设备IP">
          <el-input v-model="configForm.deviceIp" placeholder="请输入设备IP地址" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="connectDevice" :loading="isConnecting">
            {{ isConnected ? '断开连接' : '连接设备' }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 设备状态 -->
    <div class="device-status" v-if="isConnected">
      <h3>设备状态</h3>
      <el-card v-loading="isLoadingStatus">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="status-item">
              <span class="status-label">装载重量：</span>
              <span class="status-value">{{ deviceStatus.loadWeight }} 吨</span>
            </div>
            <div class="status-item">
              <span class="status-label">容重：</span>
              <span class="status-value">{{ deviceStatus.bulkDensity }} KG/M³</span>
            </div>
            <div class="status-item">
              <span class="status-label">已装车量次数：</span>
              <span class="status-value">{{ deviceStatus.loadCount }}</span>
            </div>
            <div class="status-item">
              <span class="status-label">总闸开关：</span>
              <span class="status-value" :class="deviceStatus.mainSwitch ? 'status-on' : 'status-off'">
                {{ deviceStatus.mainSwitch ? '开启' : '关闭' }}
              </span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="status-item">
              <span class="status-label">手动开启：</span>
              <span class="status-value" :class="deviceStatus.manualOpen ? 'status-on' : 'status-off'">
                {{ deviceStatus.manualOpen ? '开启' : '关闭' }}
              </span>
            </div>
            <div class="status-item">
              <span class="status-label">手动关闭：</span>
              <span class="status-value" :class="deviceStatus.manualClose ? 'status-on' : 'status-off'">
                {{ deviceStatus.manualClose ? '开启' : '关闭' }}
              </span>
            </div>
            <div class="status-item">
              <span class="status-label">自动运行：</span>
              <span class="status-value" :class="deviceStatus.autoRun ? 'status-on' : 'status-off'">
                {{ deviceStatus.autoRun ? '开启' : '关闭' }}
              </span>
            </div>
            <div class="status-item">
              <span class="status-label">装满关闭：</span>
              <span class="status-value" :class="deviceStatus.fullClose ? 'status-on' : 'status-off'">
                {{ deviceStatus.fullClose ? '开启' : '关闭' }}
              </span>
            </div>
            <div class="status-item">
              <span class="status-label">缺料指示：</span>
              <span class="status-value" :class="deviceStatus.lackMaterial ? 'status-on' : 'status-off'">
                {{ deviceStatus.lackMaterial ? '缺料' : '正常' }}
              </span>
            </div>
            <div class="status-item">
              <span class="status-label">手动/自动：</span>
              <span class="status-value" :class="deviceStatus.manualAuto ? 'status-on' : 'status-off'">
                {{ deviceStatus.manualAuto ? '手动' : '自动' }}
              </span>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>

    <!-- 设备控制 -->
    <div class="device-control" v-if="isConnected">
      <h3>设备控制</h3>
      <el-card>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-button type="primary" @click="openDevice" :loading="isControlling">
              开启设备
            </el-button>
          </el-col>
          <el-col :span="12">
            <el-button type="danger" @click="closeDevice" :loading="isControlling">
              关闭设备
            </el-button>
          </el-col>
        </el-row>
      </el-card>
    </div>

    <!-- 参数设置 -->
    <div class="parameter-setting" v-if="isConnected">
      <h3>参数设置</h3>
      <el-card>
        <el-form :model="paramForm" label-width="100px">
          <el-form-item label="装载重量">
            <el-input-number v-model="paramForm.loadWeight" :min="0" :step="0.1" placeholder="请输入装载重量" />
            <span class="unit">吨</span>
          </el-form-item>
          <el-form-item label="容重">
            <el-input-number v-model="paramForm.bulkDensity" :min="0" :step="0.1" placeholder="请输入容重" />
            <span class="unit">KG/M³</span>
          </el-form-item>
          <el-form-item label="手动/自动">
            <el-switch v-model="paramForm.manualAuto" />
            <span class="switch-label">{{ paramForm.manualAuto ? '手动' : '自动' }}</span>
          </el-form-item>
          <el-form-item label="自动运行">
            <el-switch v-model="paramForm.autoRun" />
          </el-form-item>
          <el-form-item label="装满关闭">
            <el-switch v-model="paramForm.fullClose" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveParameters" :loading="isSaving">
              保存参数
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModbusDevice',
  data() {
    return {
      configForm: {
        deviceIp: ''
      },
      paramForm: {
        loadWeight: 0,
        bulkDensity: 0,
        manualAuto: false,
        autoRun: false,
        fullClose: false
      },
      deviceStatus: {
        loadWeight: 0,
        bulkDensity: 0,
        loadCount: 0,
        manualOpen: false,
        manualClose: false,
        autoRun: false,
        fullClose: false,
        lackMaterial: false,
        manualAuto: false,
        mainSwitch: false
      },
      isConnected: false,
      isConnecting: false,
      isLoadingStatus: false,
      isControlling: false,
      isSaving: false
    }
  },
  methods: {
    async connectDevice() {
      if (!this.configForm.deviceIp) {
        this.$message.error('请输入设备IP地址');
        return;
      }

      this.isConnecting = true;
      try {
        if (this.isConnected) {
          // 断开连接
          this.isConnected = false;
          this.$message.success('设备已断开连接');
        } else {
          // 连接设备并获取状态
          await this.getDeviceStatus();
          this.isConnected = true;
          this.$message.success('设备连接成功');
          // 初始化参数表单
          this.initParamForm();
        }
      } catch (error) {
        this.$message.error('连接设备失败: ' + error.message);
      } finally {
        this.isConnecting = false;
      }
    },

    async getDeviceStatus() {
      this.isLoadingStatus = true;
      try {
        const response = await this.$axios.get('/api/modbus/status', {
          params: { deviceIp: this.configForm.deviceIp }
        });
        if (response.data.code === 200) {
          this.deviceStatus = response.data.data;
        } else {
          throw new Error(response.data.msg);
        }
      } catch (error) {
        throw error;
      } finally {
        this.isLoadingStatus = false;
      }
    },

    async openDevice() {
      this.isControlling = true;
      try {
        const response = await this.$axios.post('/api/modbus/open', {
          deviceIp: this.configForm.deviceIp
        });
        if (response.data.code === 200) {
          this.$message.success('设备开启成功');
          // 刷新状态
          await this.getDeviceStatus();
        } else {
          this.$message.error('开启设备失败: ' + response.data.msg);
        }
      } catch (error) {
        this.$message.error('开启设备失败: ' + error.message);
      } finally {
        this.isControlling = false;
      }
    },

    async closeDevice() {
      this.isControlling = true;
      try {
        const response = await this.$axios.post('/api/modbus/close', {
          deviceIp: this.configForm.deviceIp
        });
        if (response.data.code === 200) {
          this.$message.success('设备关闭成功');
          // 刷新状态
          await this.getDeviceStatus();
        } else {
          this.$message.error('关闭设备失败: ' + response.data.msg);
        }
      } catch (error) {
        this.$message.error('关闭设备失败: ' + error.message);
      } finally {
        this.isControlling = false;
      }
    },

    initParamForm() {
      this.paramForm.loadWeight = this.deviceStatus.loadWeight;
      this.paramForm.bulkDensity = this.deviceStatus.bulkDensity;
      this.paramForm.manualAuto = this.deviceStatus.manualAuto;
      this.paramForm.autoRun = this.deviceStatus.autoRun;
      this.paramForm.fullClose = this.deviceStatus.fullClose;
    },

    async saveParameters() {
      this.isSaving = true;
      try {
        // 保存装载重量
        if (this.paramForm.loadWeight !== this.deviceStatus.loadWeight) {
          const weightResponse = await this.$axios.post('/api/modbus/load-weight', {
            deviceIp: this.configForm.deviceIp,
            weight: this.paramForm.loadWeight
          });
          if (weightResponse.data.code !== 200) {
            throw new Error('保存装载重量失败: ' + weightResponse.data.msg);
          }
        }

        // 保存容重
        if (this.paramForm.bulkDensity !== this.deviceStatus.bulkDensity) {
          const densityResponse = await this.$axios.post('/api/modbus/bulk-density', {
            deviceIp: this.configForm.deviceIp,
            density: this.paramForm.bulkDensity
          });
          if (densityResponse.data.code !== 200) {
            throw new Error('保存容重失败: ' + densityResponse.data.msg);
          }
        }

        // 保存手动/自动状态
        if (this.paramForm.manualAuto !== this.deviceStatus.manualAuto) {
          const manualAutoResponse = await this.$axios.post('/api/modbus/manual-auto', {
            deviceIp: this.configForm.deviceIp,
            status: this.paramForm.manualAuto
          });
          if (manualAutoResponse.data.code !== 200) {
            throw new Error('保存手动/自动状态失败: ' + manualAutoResponse.data.msg);
          }
        }

        // 保存自动运行状态
        if (this.paramForm.autoRun !== this.deviceStatus.autoRun) {
          const autoRunResponse = await this.$axios.post('/api/modbus/auto-run', {
            deviceIp: this.configForm.deviceIp,
            status: this.paramForm.autoRun
          });
          if (autoRunResponse.data.code !== 200) {
            throw new Error('保存自动运行状态失败: ' + autoRunResponse.data.msg);
          }
        }

        // 保存装满关闭状态
        if (this.paramForm.fullClose !== this.deviceStatus.fullClose) {
          const fullCloseResponse = await this.$axios.post('/api/modbus/full-close', {
            deviceIp: this.configForm.deviceIp,
            status: this.paramForm.fullClose
          });
          if (fullCloseResponse.data.code !== 200) {
            throw new Error('保存装满关闭状态失败: ' + fullCloseResponse.data.msg);
          }
        }

        this.$message.success('参数保存成功');
        // 刷新状态
        await this.getDeviceStatus();
      } catch (error) {
        this.$message.error('保存参数失败: ' + error.message);
      } finally {
        this.isSaving = false;
      }
    }
  }
}
</script>

<style scoped>
.modbus-device {
  padding: 20px;
}

.device-config {
  margin-bottom: 20px;
}

.device-status {
  margin-bottom: 20px;
}

.device-control {
  margin-bottom: 20px;
}

.parameter-setting {
  margin-bottom: 20px;
}

.status-item {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.status-label {
  width: 120px;
  font-weight: 500;
}

.status-value {
  font-weight: 500;
}

.status-on {
  color: #67c23a;
}

.status-off {
  color: #f56c6c;
}

.unit {
  margin-left: 10px;
  color: #909399;
}

.switch-label {
  margin-left: 10px;
  color: #606266;
}
</style>
